var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "postcode-lookup" },
    [
      _c("label", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFullAddress,
              expression: "showFullAddress",
            },
          ],
          staticClass: "postcode-lookup__address",
        },
        [
          _c("Input", {
            attrs: {
              name: 0,
              label: "Address Line 1",
              placeholder: "Address Line 1",
              required: true,
              title: _vm.titles.lettersAndNumbers,
              vuexPath: [..._vm.vuexPath, "fields", "addressLines"],
            },
            on: { change: _vm.unsetAddressVerified },
          }),
          _vm._v(" "),
          _c("Input", {
            attrs: {
              name: 1,
              label: "Address Line 2",
              placeholder: "Address Line 2",
              pattern: _vm.patterns.lettersAndNumbers,
              title: _vm.titles.lettersAndNumbers,
              vuexPath: [..._vm.vuexPath, "fields", "addressLines"],
            },
            on: { change: _vm.unsetAddressVerified },
          }),
          _vm._v(" "),
          _c("Input", {
            attrs: {
              name: "town",
              label: "Town / City",
              placeholder: "Town / City",
              required: true,
              pattern: _vm.patterns.lettersAndNumbers,
              title: _vm.titles.lettersAndNumbers,
              vuexPath: _vm.vuexPath,
            },
            on: { change: _vm.unsetAddressVerified },
          }),
          _vm._v(" "),
          _c("Input", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasCounty,
                expression: "hasCounty",
              },
            ],
            attrs: {
              name: "county",
              label: "County",
              placeholder: "County",
              required: !_vm.hasCounty,
              pattern: _vm.patterns.lettersAndNumbers,
              title: _vm.titles.lettersAndNumbers,
              vuexPath: _vm.vuexPath,
            },
            on: { change: _vm.unsetAddressVerified },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "country-wrapper" },
            [
              _c("Input", {
                attrs: {
                  name: "country",
                  label: "Country",
                  placeholder: "Country",
                  required: true,
                  title: _vm.titles.lettersAndNumbers,
                  vuexPath: _vm.vuexPath,
                  value: _vm.title,
                  options: _vm.countryOptions,
                },
                on: { change: _vm.unsetAddressVerified },
              }),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "postcode-lookup__search" }, [
        _c(
          "div",
          { staticClass: "postcode-lookup__postcode" },
          [
            _c("Input", {
              attrs: {
                name: "postCode",
                label: "Postcode",
                placeholder: "Postcode",
                required: true,
                pattern: _vm.patterns.postcode,
                title: _vm.titles.postcode,
                vuexPath: _vm.vuexPath,
              },
              on: { change: _vm.unsetAddressVerified },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn postcode-lookup__button",
            attrs: {
              type: "button",
              disabled: !_vm.address.postCode || !_vm.address.postCode.length,
              "aria-label": "Lookup address",
              title: "Lookup address",
            },
            on: { click: _vm.search },
          },
          [_vm._v("\n      Lookup\n    ")]
        ),
        _vm._v(" "),
        _vm.addresses.length
          ? _c(
              "ul",
              { staticClass: "postcode-lookup__results" },
              _vm._l(_vm.addresses, function (address) {
                return _c("li", { key: address.id }, [
                  _c(
                    "button",
                    {
                      staticClass: "postcode-lookup__result",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.setAddress(address.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(address.description))]
                  ),
                ])
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.noResults
        ? _c("div", { staticClass: "postcode-lookup__error error-message" }, [
            _c("div", { staticClass: "error-message__icon" }),
            _vm._v(" "),
            _vm._m(0),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.showFullAddress
        ? _c(
            "button",
            {
              staticClass: "link",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.manualInput = true
                },
              },
            },
            [_vm._v("Enter address manually")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("Input", {
        ref: "addressVerified",
        attrs: {
          name: "addressVerified",
          type: "hidden",
          vuexPath: _vm.vuexPath,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "error-message__text" }, [
      _c("p", [
        _vm._v(
          "No results found. Please check the postcode or enter the address manually."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }